

// Host-Name ermitteln
if (window.location.hostname == 'localhost') {
    var baseUrl = 'http://localhost:' + window.location.port + '/';
} else {
    var hostUrl = window.location.protocol + '//' + window.location.host + '/';
    var baseUrl = hostUrl + 'typo3conf/ext/nnconfigurator/Resources/Vue/dist/';
}

export const HOST_URL = hostUrl;
export const BASE_URL = baseUrl;

// Pfad zur Backend-Api
export const API_URL    = HOST_URL + "api/";
export const ASSETS_URL = BASE_URL + "static/images/";
export const DATA_URL   = BASE_URL + "static/data/";



// WEBPACK FOOTER //
// ./src/common/config.js